import { render, staticRenderFns } from "./PaymentMethods copy.vue?vue&type=template&id=8fd3ba14"
import script from "./PaymentMethods copy.vue?vue&type=script&lang=js"
export * from "./PaymentMethods copy.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethods copy.vue?vue&type=style&index=0&id=8fd3ba14&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports